<template>
  <div class="info position-relative">
    <img src="../../assets/img/info/logo.png" alt="" srcset="" class="logo" />
    <div class="cnt">
      <img
        src="../../assets/img/info/slogn.png"
        alt=""
        srcset=""
        class="slogn"
      />
      <div class="btn cursor">
         <img src="../../assets/img/info/ios.png" alt="" srcset=""    @click="handleIOS('ios')"/>
          <img src="../../assets/img/info/gp.png" alt="" srcset="" @click="handleGP('gp')"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {};
  },
  methods: {
    handleIOS(val) {
      this.common.goShare(val);
    },
     handleGP(val) {
      this.common.goShare(val);
    },
  },
  watch: {}
};
</script>
<style lang="scss">
.info {
  height: 1080px;
  width: 100%;

  background-image: url("../../assets/img/info/bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .logo {
    width: 201px;
    height: auto;
    position: absolute;
    left: 30px;
    top: 75px;
  }
  .cnt {
      position: absolute;
    right: 0;
    bottom: 8vw;
     display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .slogn {
      width: 893px;
      height: auto;
    }
    .btn {
        img {
            width: 311px;
      height: auto;

        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mainComponents/info.vue